const {addFilter}         = wp.hooks;
const {InspectorControls} = wp.editor;

const {
          PanelBody, PanelRow,
          TextControl, SelectControl, RangeControl,
          ButtonGroup, Button, Icon
      } = wp.components;

const {__}                         = wp.i18n;
const {Fragment}                   = wp.element;
const {createHigherOrderComponent} = wp.compose;
const {ToggleControl}              = wp.components;

function filterCoverBlockAlignments(settings, name) {

    if (name === "core/group") {

        settings.attributes.padding = {
            type:    'string',
            default: "",
        };

        settings.attributes.padding_selected = {
            type:    'string',
            default: "",
        };

        settings.attributes.padding_class = {
            type:    'string',
            default: "",
        };
    }

    return settings;
}

addFilter(
    'blocks.registerBlockType',
    'intro-to-filters/cover-block/alignment-settings',
    filterCoverBlockAlignments,
);

/**
 * Add mobile visibility controls on Advanced Block Panel.
 *
 * @param {function} BlockEdit Block edit component.
 *
 * @return {function} BlockEdit Modified block edit component.
 */
const withAdvancedControls = createHigherOrderComponent((BlockEdit, otro) => {

    return (props) => {

        const {
                  attributes,
                  setAttributes,
                  isSelected,
              } = props;


        const change_spacing = (key) => {

            console.log("click in change spacing " + key)

            if (!props.isSelected || typeof (key) === "undefined") {
                return true;
            }

            let value = "has-no-padding";

            if (key === "none") {
                value = 0;
            } else if (key === "s") {
                value = 4;
            } else if (key === "m") {
                value = 8;
            } else if (key === "l") {
                value = 16;
            } else if (key === "xl") {
                value = 36;
            } else if (key === "custom") {
                value = false;
            }

            console.log("K " + key + " V " + value)

            props.setAttributes({"padding_selected": key});

            if (value !== false) {

                props.setAttributes({"padding": value});

            }
            props.attributes.className = get_padding_class(key);
            props.setAttributes({"padding_class": get_padding_class(key)});
            props.setAttributes({"className": get_padding_class(key)});
            props.setAttributes({updated: Date.now()});

        }

        const SpacingButton = (attrs) => {

            let label   = attrs.label;
            let key     = attrs.value;
            let variant = "";

            if (props.attributes.padding_selected === key) {
                variant = "primary";
            }

            let icon = false;

            if (label === "custom") {
                label = "";
                icon  = <Icon icon={() => (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15"
                         aria-hidden="true" focusable="false">
                        <path
                            d="M14.5 13.8c-1.1 0-2.1.7-2.4 1.8H4V17h8.1c.3 1 1.3 1.8 2.4 1.8s2.1-.7 2.4-1.8H20v-1.5h-3.1c-.3-1-1.3-1.7-2.4-1.7zM11.9 7c-.3-1-1.3-1.8-2.4-1.8S7.4 6 7.1 7H4v1.5h3.1c.3 1 1.3 1.8 2.4 1.8s2.1-.7 2.4-1.8H20V7h-8.1z"></path>
                    </svg>
                )}/>
            }

            return (
                <Button variant={variant} onClick={(v) => (change_spacing(key))} icon={icon}>{label}</Button>
            );

        }

        let render_flag  = props.name === "core/group";
        const extra_flag = isSelected && render_flag;

        const get_padding_class = (value = "") => {

            if( value === "" ){
                value = props.attributes.padding_selected;
            }

            let padding_class = "has-no-padding";

            if( value === "none" ) {
                padding_class = "has-no-padding";
            }else if( value === "xs" ){
                padding_class = "has-extra-small-padding";
            }else if( value === "s" ){
                padding_class = "has-small-padding";
            }else if( value === "m" ){
                padding_class = "has-medium-padding";
            }else if( value === "l" ){
                padding_class = "has-large-padding";
            }else if( value === "xl" ){
                padding_class = "has-extra-large-padding";
            }

            let current_className = props.attributes.className;

            current_className = current_className.replace(" has-no-padding", "");
            current_className = current_className.replace(" has-extra-small-padding", "");
            current_className = current_className.replace(" has-small-padding", "");
            current_className = current_className.replace(" has-medium-padding", "");
            current_className = current_className.replace(" has-large-padding", "");
            current_className = current_className.replace(" has-extra-large-padding", "");

            return current_className + " " + padding_class;

        }

        return (
            <Fragment>
                <BlockEdit {...props} />
                {extra_flag &&
                    <InspectorControls key="inspector">

                        <PanelBody key="panel_body_carousel" title={__('Padding')}
                                   className={"aws-full-post-list aws-rm-hidden"}>

                            <PanelRow
                                className={"aws-post-list-sidebar"}
                                lable={"nga label"}
                            >

                                <ButtonGroup>

                                    <SpacingButton value={"none"} label={"None"}/>
                                    <SpacingButton value={"s"} label={"S"}/>
                                    <SpacingButton value={"m"} label={"M"}/>
                                    <SpacingButton value={"l"} label={"L"}/>
                                    <SpacingButton value={"xl"} label={"XL"}/>

                                </ButtonGroup>

                            </PanelRow>

                        </PanelBody>
                    </InspectorControls>
                }

            </Fragment>
        );
    };
}, 'withAdvancedControls');

addFilter(
    'editor.BlockEdit',
    'editorskit/custom-advanced-control',
    withAdvancedControls
);
